import api from './client';

export const getCables = (projectId) => api.get('/cables', { params: { project: projectId } });
export const createCable = (data) => api.post('/cables', data);
export const updateCable = (id, data) => api.put(`/cables/${id}`, data);
export const deleteCable    = (id) => api.delete(`/cables/${id}`);
export const patchCablePulled = (id, pulled) => api.patch(`/cables/${id}/pulled`, { pulled });
